export default __webpack_public_path__ + "static/media/preview.beaf1d64.png";